import { Component, Inject, OnInit } from '@angular/core';
import { FlexModule } from '@angular/flex-layout';
import { MatButton, MatIconButton } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { E911DocumentModel } from '../../../../api/models';
import { SafeResourceUrl } from '@angular/platform-browser';
import { Angular2PromiseButtonModule } from 'angular2-promise-buttons';

export interface E911SignDocumentDialogData {
  document: E911DocumentModel;
  pbxAccountId: string;
}

@Component({
  selector: 'app-e911-address-sign-document-dialog',
  standalone: true,
  imports: [
    MatDialogContent,
    MatDialogTitle,
    MatDialogActions,
    MatDialogClose,
    MatIcon,
    FlexModule,
    MatButton,
    MatIconButton,
    Angular2PromiseButtonModule,
  ],
  templateUrl: './e911-sign-document-dialog.component.html',
  styleUrl: './e911-sign-document-dialog.component.scss',
})
export class E911SignDocumentDialogComponent implements OnInit {
  public isCreatingLocation: boolean;

  docUrl!: SafeResourceUrl;

  constructor(
    @Inject(MAT_DIALOG_DATA) private readonly _data: E911SignDocumentDialogData,
    private readonly _dialogRef: MatDialogRef<E911SignDocumentDialogComponent>,
  ) {}

  public ngOnInit(): void {
    this.openSignWell();
  }

  private openSignWell(): void {
    const { signUrl, documentId } = this._data.document || {};
    const url = signUrl || `https://www.signwell.com/app/preview/document/${documentId}`;

    // @ts-ignore
    var signWellEmbed = new SignWellEmbed({
      url,
      containerId: 'signwell-container',
      allowClose: false,
      allowDecline: false,
      showSendButton: false,
      events: {
        completed: e => {},
        closed: e => {
          this._dialogRef.close();
        },
      },
    });

    signWellEmbed.open();
  }

  private listenPandaDocEvents(): void {
    window.addEventListener('message', event => {
      const type = event.data && event.data.type;
      const payload = event.data && event.data.payload;

      switch (type) {
        case 'session_view.document.loaded':
          console.log('Session view is loaded');
          break;
        case 'session_view.document.completed':
          console.log('Document is completed');

          break;
        case 'session_view.document.exception':
          console.log('Exception during document finalization');
          console.log(payload);
      }
    });
  }
}
